import http from './utils';
import { mockPrefix, prefix } from './constants';

export const getOverviewTopicTimelineNew: (
  payload: any,
) => Promise<any> = payload => {
  return http({
    url: `${prefix}/overview/topic_stats_timeline`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};




export const getOverviewKeywordNew: (payload: any) => Promise<any> = payload => {
  return http({
    url: `${prefix}/overview/keyword`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

 